var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJustpointMonogramBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 33.7648C32.0792 33.7648 33.7648 32.0793 33.7648 30C33.7648 27.9208 32.0792 26.2352 30 26.2352C27.9207 26.2352 26.2352 27.9208 26.2352 30C26.2352 32.0793 27.9207 33.7648 30 33.7648Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6111 27.3611C17.6111 28.3519 17.5519 28.9926 17.2426 29.6815H10V33.3407H13.5556C16.1741 33.3407 18.3926 32.4704 19.9704 30.8241C21.5519 29.1741 22.387 26.8481 22.387 24.0963V8.99074L23.113 8.42222L26.6648 8.20556V6.66852H13.3333V8.20556L16.8852 8.42222L17.6111 8.99074V27.363V27.3611Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJustpointMonogramBlack);
export default __webpack_public_path__ + "static/media/justpoint_monogram_black.4030742f5dc3cd4277347f800dc64cc5.svg";
export { ForwardRef as ReactComponent };